<script lang="ts">
import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'

export const statValueVariants = cva('font-display font-semibold tracking-snug text-primary-900', {
  variants: {
    size: {
      sm: 'text-md/5',
      md: 'text-xl/6',
      lg: 'text-2xl/7',
    },
  },
  defaultVariants: {
    size: 'md',
  },
})

export type StatValueVariants = VariantProps<typeof statValueVariants>
</script>

<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '#ui-kit/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
  size?: StatValueVariants['size']
}>()
</script>

<template>
  <span data-slot="stat-value" :data-size="size ?? 'md'" :class="cn(statValueVariants({ size }), props.class)">
    <slot />
  </span>
</template>
